import NoticeList from '@/views/kindergarten/notice/NoticeList';
import NoticeAdd from '@/views/kindergarten/notice/NoticeAdd';
import NoticeEdit from '@/views/kindergarten/notice/NoticeEdit';
import NoticeDetail from '@/views/kindergarten/notice/NoticeDetail';

import SettingIndex from '@/views/kindergarten/setting/SettingIndex';

import TemplateList from '@/views/kindergarten/setting/TemplateList';
import TemplateAdd from '@/views/kindergarten/setting/TemplateAdd';
import TemplateEdit from '@/views/kindergarten/setting/TemplateEdit';
import TemplateDetail from '@/views/kindergarten/setting/TemplateDetail';

import messageTemplateList from '@/views/messageTemplate/MessageTemplateList';

import SignupList from '@/views/kindergarten/signup/SignupList';
import SignupDetail from '@/views/kindergarten/signup/SignupDetail';

import OuterNotice from '@/views/kindergarten/outer/OuterNotice';
import OuterLogin from '@/views/kindergarten/outer/OuterLogin';
import OuterQuestionnaire from '@/views/kindergarten/outer/OuterQuestionnaire';

export const kindergartenMainRouterList = [{
    path: 'kindergarten/notice/noticeList',
    name: 'KindergartenNoticeList',
    component: NoticeList


}, {
    path: 'kindergarten/notice/noticeAdd',
    name: 'KindergartenNoticeAdd',
    component: NoticeAdd
}, {
    path: 'kindergarten/notice/noticeEdit',
    name: 'KindergartenNoticeEdit',
    component: NoticeEdit
}, {
    path: 'kindergarten/notice/noticeDetail',
    name: 'KindergartenNoticeDetail',
    component: NoticeDetail
}, {
    path: 'kindergarten/setting/settingIndex',
    name: 'KindergartenSettingIndex',
    component: SettingIndex
}, {
    path: 'kindergarten/setting/template/templateList',
    name: 'KindergartenTemplateList',
    component: TemplateList
}, {
    path: 'kindergarten/setting/template/templateAdd',
    name: 'KindergartenTemplateAdd',
    component: TemplateAdd
}, {
    path: 'kindergarten/setting/template/templateEdit',
    name: 'KindergartenTemplateEdit',
    component: TemplateEdit
}, {
    path: 'kindergarten/setting/template/templateDetail',
    name: 'KindergartenTemplateDetail',
    component: TemplateDetail
}, {
    path: 'kindergarten/setting/messageTemplateList',
    name: 'KindergartenMessageTemplateList',
    component: messageTemplateList
}, {
    path: 'kindergarten/setting/createTemplate',
    name: 'KindergartenCreateTemplate',
    component: () => import('@/views/messageTemplate/createTemplate')
}, {
    path: 'kindergarten/signup/signupList',
    name: 'KindergartenSignupList',
    component: SignupList
}, {
    path: 'kindergarten/signup/signupDetail',
    name: 'KindergartenSignupDetail',
    component: SignupDetail
}];
export const kindergartenOuterRouterList = [{
    path: '/kindergarten/outer/outerNotice',
    name: 'KindergartenOuterNotice',
    component: OuterNotice
}, {
    path: '/kindergarten/outer/outerLogin',
    name: 'KindergartenOuterLogin',
    component: OuterLogin
}, {
    path: '/kindergarten/outer/outerQuestionnaire',
    name: 'KindergartenOuterQuestionnaire',
    component: OuterQuestionnaire
}];






// WEBPACK FOOTER //
// ./src/router/kindergarten.js